<template>
    <div v-html="html" class="html"></div>
</template>

<script>
export default {
    name: 'EmailBodyPopUp',
    data: () => ({
        html: ''
    }),
    mounted() {
        var view = this
        view.$utils.xhr({
            url: view.$url('EMAIL_BODY_HTML'),
            data: view.$route.params,
            contentType: 'application/json',
            type: 'POST'
        }).then(function(response) {
            let data = JSON.parse(response)
            view.html = data.data
        })
    }
}
</script>

<style>
.html table.container {
    padding: 0!important;
}
</style>